export default () => ({
  all: [],
  my: [],
  subaffilaite: [],
  offer: {},
});
